/**
 * @generated SignedSource<<485f6e2b1d6a1ce19806aae95d89f35e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyOpenOpportunityListV2_organization$data = {
  readonly averageJobValue: any;
  readonly completedJobsCount: number;
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly visitorIsMember: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewJobSectionEmptyState_organization">;
  readonly " $fragmentType": "CompanyOpenOpportunityListV2_organization";
};
export type CompanyOpenOpportunityListV2_organization$key = {
  readonly " $data"?: CompanyOpenOpportunityListV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyOpenOpportunityListV2_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyOpenOpportunityListV2_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "averageJobValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedJobsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewJobSectionEmptyState_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "4a0e3e20d5bf89be24b877884c4a3fd4";

export default node;
